import React from "react";
import config from "../../config/config";

class NavBar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

    }

    render() {
        return (
            <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
                <div className="container">
                    <a className="navbar-brand" href={config.rootPath}>Engineering Guru</a>
                    <button className="navbar-toggler" type="button" data-toggle="collapse"
                            data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false"
                            aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarResponsive">
                        <ul className="navbar-nav ml-auto">
                            <li className="nav-item">
                                <a className="nav-link" href={config.rootPath}>Home</a>
                            </li>
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#menu" id="coursesMenu" role="button"
                                   data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Programs
                                </a>
                                <div className="dropdown-menu" aria-labelledby="coursesMenu">
                                    <a className="dropdown-item" href={config.rootPath+config.professionalDevelopmentPath}>Professional Development</a>
                                    <a className="dropdown-item" href={config.rootPath+config.engineeringCoursesPath}>Engineering Courses</a>
                                    <div className="dropdown-divider"></div>
                                    <a className="dropdown-item" href={config.rootPath+config.remoteInternshipsPath}>Remote Internships</a>
                                </div>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href={config.rootPath+config.joinUsPath}>Join Us</a>
                            </li>
			    <li className="nav-item">
				<a className="nav-link" href="https://engg-guru-resume-x.web.app/" target="_blank">ResumeX</a>
			    </li>
                        </ul>
                    </div>
                </div>
            </nav>
        );
    }
}

NavBar.propTypes = {};

export default NavBar;
